import { Avatar, Button, ConfigProvider } from 'antd';
import React from 'react';
import WebStyle from '../../../../styles/style-web.json';

function HeavyModule({
  heroModule,
  centerAlign,
  title,
  authorImage,
  authorName,
  authorSubTitle,
  date,
  secondaryButton,
  primaryButton,
  cmsContent,
  responsive,
  backgroundImage
}) {
  return (
    <ConfigProvider theme={WebStyle}>
      <section
        className={`heavy-module ${heroModule && 'heromodule'} ${
          responsive ? 'responsive-view' : ''
        }`}
      >
        {heroModule && backgroundImage && (
          <div className="cover-img">
            <img src={backgroundImage} fill objectFit="cover" alt="images" />
          </div>
        )}
        <div className="container">
          <div className="heavy-module-container">
            {title && (
              <h2 className={`${centerAlign && 'text-center'}`}>{title}</h2>
            )}
            {authorName && (
              <div className={`author ${centerAlign && 'justify-center'}`}>
                <Avatar src={authorImage} size="small" />
                <div className="author-content">
                  <div className="author-name">{authorName}</div>
                  <p> {authorSubTitle}</p>
                </div>
              </div>
            )}
            {date && (
              <div className={`date mb-16 ${centerAlign && 'text-center'}`}>
                {date}
              </div>
            )}
            {cmsContent && <pre className="cms-content">{cmsContent}</pre>}
            <div
              className={`button-wrapper ${centerAlign && 'justify-center'}`}
            >
              {secondaryButton && (
                <Button
                  size="large"
                  className={`cs-button ${
                    heroModule
                      ? 'bg-transparent b-1 b-n-100 text-n-100 hb-n-100 hbg-n-100 hc-n-900'
                      : ' bg-n-transparent text-n-900 text-n-100 hbg-n-900 hc-n-100 hb-n-900'
                  }`}
                >
                  {secondaryButton}
                </Button>
              )}
              {primaryButton && (
                <Button
                  size="large"
                  className={`cs-button ${
                    heroModule
                      ? 'bg-n-100 text-n-900 hbg-transparent hc-n-100 hb-n-100'
                      : ' bg-n-900 text-n-100 hbg-ivory hb-n-900 hc-n-900'
                  }`}
                >
                  {primaryButton}
                </Button>
              )}
            </div>
          </div>
        </div>
      </section>
    </ConfigProvider>
  );
}
export default HeavyModule;
